module.exports={
	"ak": 4,
	"ar": 7,
	"ay": 10,
	"az": 11,
	"cr": 26,
	"et": 40,
	"fa": 42,
	"ff": 43,
	"gn": 52,
	"ik": 69,
	"iu": 74,
	"kg": 81,
	"kr": 89,
	"ku": 91,
	"kv": 92,
	"lv": 103,
	"mg": 104,
	"mn": 109,
	"ms": 112,
	"ne": 118,
	"no": 122,
	"oj": 127,
	"om": 128,
	"or": 129,
	"ps": 134,
	"qu": 136,
	"sc": 143,
	"sh": 147,
	"sq": 154,
	"sw": 160,
	"uz": 178,
	"yi": 185,
	"za": 187,
	"zh": 188,
	"bal": 719,
	"bik": 917,
	"bnc": 1036,
	"bua": 1205,
	"chm": 1455,
	"del": 1751,
	"den": 1753,
	"din": 1805,
	"doi": 1881,
	"gba": 2223,
	"gon": 2415,
	"grb": 2436,
	"hai": 2545,
	"hmn": 2622,
	"jrb": 3005,
	"kln": 3319,
	"kok": 3392,
	"kpe": 3409,
	"lah": 3693,
	"luy": 4000,
	"man": 4033,
	"mwr": 4583,
	"raj": 5755,
	"rom": 5860,
	"syr": 6407,
	"tmh": 6676,
	"zap": 7957,
	"zza": 8124
}
